import { buttonClickEvent, linkClickEvent, inputEvent, makeCatalogEvent, prependCatalogName } from '@dashboard/junk-drawer/utils/eventstream';
import { BulkActionsEvents, BulkItemEditEvents } from '@dashboard/shared-constants/events/retail/bulk-edit/event-primitives';
export let ModifiersSource = /*#__PURE__*/function (ModifiersSource) {
  ModifiersSource["MODIFIERS_PAGE"] = "Modifiers Page";
  ModifiersSource["EDIT_MODIFIERS_PAGE"] = "Edit Modifiers Page";
  ModifiersSource["ITEM_EDIT_SHEET"] = "Item Edit Sheet";
  return ModifiersSource;
}({});
export let EventSource = /*#__PURE__*/function (EventSource) {
  EventSource["BetaOptInModal"] = "Try New Categories Modal";
  EventSource["CategoriesPage"] = "Categories Page";
  EventSource["CategorySheet"] = "Category Sheet";
  EventSource["CategoryRow"] = "Category Row";
  EventSource["PopoverMenu"] = "Popover Menu";
  EventSource["AssignItemsModal"] = "Item Assignment Modal";
  EventSource["RearrangeItemsModal"] = "Rearrange Items Modal";
  EventSource["PageSheerErrors"] = "page / sheet triggered errors";
  EventSource["ItemSheet"] = "Item Sheet";
  EventSource["ServiceSheet"] = "Service Sheet";
  EventSource["PackageSheet"] = "Package Sheet";
  EventSource["BulkEdit"] = "Bulk Edit";
  EventSource["ItemLibrary"] = "Item Library";
  EventSource["CatalogImportModal"] = "Catalog Import Modal";
  EventSource["IngredientSelectionModal"] = "Ingredient Selection Modal";
  EventSource["ComboChoiceModal"] = "Combo Choice Modal";
  EventSource["MeasurementUnitModal"] = "Measurement Unit Modal";
  EventSource["RecipeUnitModal"] = "Recipe Measurement Unit Modal";
  EventSource["CreateVariationModal"] = "Create Variation Modal";
  return EventSource;
}({});
export let ItemCreatedSource = /*#__PURE__*/function (ItemCreatedSource) {
  ItemCreatedSource["POS_ONBOARDING"] = "POS Onboarding";
  ItemCreatedSource["QUICK_CREATE"] = "Quick Create";
  ItemCreatedSource["FULL_CREATE"] = "Full Create";
  ItemCreatedSource["EASY_CREATE"] = "Full Create with Easy Create";
  ItemCreatedSource["LIBRARY_QUICK_CREATE"] = "Library Quick Create";
  return ItemCreatedSource;
}({});
const ITEM_LIBRARY_CATALOG_NAME = 'catalog_feature_interaction';
export function catalogItemLibraryEventCreator(featureName) {
  return function makeEvent(metadata = {}) {
    let details = metadata.details;
    if (typeof metadata.details === 'object') {
      details = JSON.stringify(metadata.details);
    }
    return makeCatalogEvent(ITEM_LIBRARY_CATALOG_NAME, prependCatalogName({
      feature_name: featureName,
      error_type: metadata.errorType,
      token: metadata.token,
      id: metadata.id,
      message: metadata.message,
      source: metadata.source,
      timing: metadata.timing,
      details
    }, ITEM_LIBRARY_CATALOG_NAME));
  };
}

/*
  Events defined here:
  https://docs.google.com/a/squareup.com/spreadsheets/d/1-NV0AhLNle1hlnVLr16LNjTH5DJ_2CBQCKKZo-UYgnU/edit?usp=sharing
*/

// Furigana
export const furiganaSuggestionClicked = catalogItemLibraryEventCreator('Furigana Suggestion Clicked');
export const furiganaSuggestionSaved = catalogItemLibraryEventCreator('Furigana Suggestion Saved');
export const furiganaSortNameEdited = catalogItemLibraryEventCreator('Furigana Sort Name Edited');

// Age Restriction
export const ageRestrictionApplied = catalogItemLibraryEventCreator('Age Restriction Applied');
export const ageRestrictionCreated = catalogItemLibraryEventCreator('Age Restriction Created');
export const ageRestrictionModalOpened = catalogItemLibraryEventCreator('Age Restriction Modal Opened');
export const ageRestrictionRemoved = catalogItemLibraryEventCreator('Age Restriction Removed');

// Categories
export const salesFilterChanged = catalogItemLibraryEventCreator('COGS Sales Filter Changed');
export const dateFilterChanged = catalogItemLibraryEventCreator('COGS Date Filter Changed');

// Discounts
export const discountCreated = catalogItemLibraryEventCreator('Discount Created');
export const discountDeleted = catalogItemLibraryEventCreator('Discount Deleted');
export const discountEdited = catalogItemLibraryEventCreator('Discount Edited');

// Taxes
export const taxCreated = buttonClickEvent('Tax Created');
export const taxDeleted = buttonClickEvent('Tax Deleted');
export const taxEdited = buttonClickEvent('Tax Edited');

// Auto Discounts
export const automaticDiscountCreated = catalogItemLibraryEventCreator('Automatic Discount: Created');
export const automaticDiscountDeleted = catalogItemLibraryEventCreator('Automatic Discount: Deleted');
export const automaticDiscountEdited = catalogItemLibraryEventCreator('Automatic Discount: Edited');
export const discountAutoApplyOn = catalogItemLibraryEventCreator('Automatic Discount: Auto Apply Enabled');
export const discountAutoApplyOff = catalogItemLibraryEventCreator('Automatic Discount: Auto Apply Disabled');
export const discountDateRangeOn = catalogItemLibraryEventCreator('Automatic Discount: Date Range Enabled');
export const discountDateRangeOff = catalogItemLibraryEventCreator('Automatic Discount: Date Range Disabled');
export const discountStartDateChanged = catalogItemLibraryEventCreator('Automatic Discount: Start Date Changed');
export const discountEndDateChanged = catalogItemLibraryEventCreator('Automatic Discount: End Date Changed');
export const discountScheduleOn = catalogItemLibraryEventCreator('Automatic Discount: Schedule Enabled');
export const discountScheduleOff = catalogItemLibraryEventCreator('Automatic Discount: Schedule Disabled');
export const discountScheduleChanged = catalogItemLibraryEventCreator('Automatic Discount: Schedule Changed');
export const discountMinimumSpendOn = catalogItemLibraryEventCreator('Automatic Discount: Minimum Spend Enabled');
export const discountMinimumSpendOff = catalogItemLibraryEventCreator('Automatic Discount: Minimum Spend Disabled');
export const discountMinimumSpendChanged = catalogItemLibraryEventCreator('Automatic Discount: Minimum Spend Changed');
export const discountMaximumDiscountOn = catalogItemLibraryEventCreator('Discount: Maximum Discount Enabled');
export const discountMaximumDiscountOff = catalogItemLibraryEventCreator('Discount: Maximum Discount Disabled');
export const discountMaximumDiscountChanged = catalogItemLibraryEventCreator('Discount: Maximum Discount Changed');

// Product Selector
export const productSelectorOpened = catalogItemLibraryEventCreator('Product Selector: Opened');
export const productSelectorSearched = catalogItemLibraryEventCreator('Product Selector: Searched');
export const productSelectorSelectionCancelled = catalogItemLibraryEventCreator('Product Selector: Selection Cancelled');
export const productSelectorSelectionSaved = catalogItemLibraryEventCreator('Product Selector: Selection Saved');

// Items
export const itemCreated = catalogItemLibraryEventCreator('Item Created');
export const itemDeleted = catalogItemLibraryEventCreator('Item Deleted');
export const itemEdited = catalogItemLibraryEventCreator('Item Edited');
export const duplicatedItemSaved = catalogItemLibraryEventCreator('Duplicated Item Saved');
export const inventoryTrackingToggled = catalogItemLibraryEventCreator('Inventory tracking toggled');
export const inventoryLowStockAlertToggled = catalogItemLibraryEventCreator('Low stock alert toggled');
export const lowStockAlertSaved = catalogItemLibraryEventCreator('Low stock alert saved');

// Item Readiness
export const itemReadinessUiRolloutFlag = 'item_readiness_ui_enabled';
export const itemEvaluated = catalogItemLibraryEventCreator('Item Readiness: Item Evaluated');
export const ItemReadinessFixIssues = catalogItemLibraryEventCreator('Item Readiness: Fix Issues Clicked');
export const ItemReadinessIgnoreIssues = catalogItemLibraryEventCreator('Item Readiness: Ignore Issues Clicked');

// Item SEO Attributes
export const itemSeoModalOpened = catalogItemLibraryEventCreator('Item SEO Attributes: Modal Opened');
export const itemSeoModalSaved = catalogItemLibraryEventCreator('Item SEO Attributes: Modal Saved');

// Item Open Graph Attributes
export const itemOpenGraphModalOpened = catalogItemLibraryEventCreator('Item Open Graph Attributes: Modal Opened');
export const itemOpenGraphModalSaved = catalogItemLibraryEventCreator('Item Open Graph Attributes: Modal Saved');

// Variations
export const variationCreated = catalogItemLibraryEventCreator('Variation Created');
export const variationDeleted = catalogItemLibraryEventCreator('Variation Deleted');
export const variationEdited = catalogItemLibraryEventCreator('Variation Edited');

// Unit Cost
export const variationUnitCostSet = catalogItemLibraryEventCreator('Cost Set on Variation');

// GTIN
export const gtinValidationError = catalogItemLibraryEventCreator('GTIN Validation Failure');
export const gtinEdited = catalogItemLibraryEventCreator('GTIN Edited');

// AutoSKU
export const autoGeneratedSKU = catalogItemLibraryEventCreator('Auto Generated SKU');
export const autoSKUSetting = catalogItemLibraryEventCreator('Auto SKU Setting Updated');
export const bulkGenerateSKUs = catalogItemLibraryEventCreator('Bulk Generate SKUs');

// Default Inventory Tracking
export const defaultInventoryTrackingUpdate = catalogItemLibraryEventCreator('Inventory Tracking Setting Updated');
export const bulkEnableInventoryTracking = catalogItemLibraryEventCreator('Bulk Enable Inventory Tracking');
export const itemInventoryTrackingUpdate = catalogItemLibraryEventCreator('Inventory Tracking Enabled/Disabled');

// Measurement Units
// "id" field of an event is digits of precision.
// For measurementUnitCreated, "details" can be "Global" or "Quick Create" to indicate where the creation comes from.
export const addCustomUnitLinkClicked = catalogItemLibraryEventCreator('Unit Section: Add Custom Unit Link Clicked');
export const measurementUnitAdded = catalogItemLibraryEventCreator('Unit Added');
export const measurementUnitCreated = catalogItemLibraryEventCreator('Unit Created');
export const unitDropdownClicked = catalogItemLibraryEventCreator('Unit Dropdown Clicked');
export const measurementUnitSearched = catalogItemLibraryEventCreator('Unit Searched');
export const measurementUnitDeleted = catalogItemLibraryEventCreator('Unit Deleted');
export const measurementUnitVariationDeleted = catalogItemLibraryEventCreator('Unit Variation Deleted');
export const measurementUnitEdited = catalogItemLibraryEventCreator('Unit Edited');
export const measurementUnitChanged = catalogItemLibraryEventCreator('Unit Changed');
export const unitPrecisionChanged = catalogItemLibraryEventCreator('FQT: Unit Precision Changed');
export const unitAbbreviationChanged = catalogItemLibraryEventCreator('FQT: Unit Abbreviation Changed');
export const clickAddAUnit = catalogItemLibraryEventCreator('Click Add a unit');
export const unitsSectionAddUnitClicked = catalogItemLibraryEventCreator('Units Section: Add unit clicked');
export const createNewUnitClicked = catalogItemLibraryEventCreator('Click Create Unit');

// Transfers
export const stockTransferred = catalogItemLibraryEventCreator('Stock Transferred');
export const unitCostExported = catalogItemLibraryEventCreator('Unit Cost Exported');
export const measurementUnitCreatedSource = {
  GLOBAL: 'Global',
  QUICK_CREATE: 'Quick Create'
};
export const measurementUnitDetails = {
  STANDARD: 'Standard',
  CUSTOM: 'Custom'
};
export const itemEditedSource = {
  FULL_EDIT: 'Full Edit'
};
export const variationEditedSource = {
  ITEM_SHEET: 'Item Sheet',
  MODAL: 'Modal'
};
export const itemOptionEditSource = {
  GLOBAL: 'Global',
  ITEM_EDIT: 'Item Edit'
};
export const autoSKUVariationCreateSource = {
  ITEM_SHEET: 'Item Sheet',
  ADD_VARIATION_DEFAULT_UNIT: 'Add Variation Default Unit',
  ADD_VARIATION_NEW_UNIT: 'Add Variation New Unit',
  EDIT_VARIATION_DEFAULT_UNIT: 'Edit Variation Default Unit',
  QUICK_CREATE: 'Quick Create',
  OPTION: 'Option Variation',
  DUPLICATE: 'Duplicate Item',
  EASY_CREATE_RELATED_VARIATIONS: 'Easy Create Related Variations',
  ADD_VARIATION_SUGGESTED_VARIATIONS: 'Add Variation Suggested Variations'
};
export const bulkGenerateSKUsSource = {
  BANNER: 'Suggested Banner',
  ACTIONS_DROP_DOWN: 'Actions Drop Down',
  SETTING: 'Setting Page',
  LABEL: 'Label Printing'
};
export const bulkGenerateSKUsStatus = {
  SUCCESS: 'Success',
  ERROR: 'Error'
};

// Modifier Sets
export const modifierAppliedToItems = catalogItemLibraryEventCreator('Modifier Option Applied To Items - Saved');
export const modifierAppliedToItem = catalogItemLibraryEventCreator('Modifier Option Applied To Item');
export const modifierListPriceOverrideAdded = catalogItemLibraryEventCreator('Modifier Set Price Override Added');
export const modifierListPriceOverrideDefaultEdited = catalogItemLibraryEventCreator('Modifier Set Default Price Edited');
export const modifierListPriceOverrideEdited = catalogItemLibraryEventCreator('Modifier Set Price Override Edited');
export const modifierListPriceOverrideRemoved = catalogItemLibraryEventCreator('Modifier Set Price Override Removed');
export const modifierListReordered = catalogItemLibraryEventCreator('Modifier Set Reordered');
export const modifierNameChanged = catalogItemLibraryEventCreator('Modifier Set Name Changed');
export const modifierOptionImageAdded = catalogItemLibraryEventCreator('Modifier Option Image Added');
export const modifierOptionImageRemoved = catalogItemLibraryEventCreator('Modifier Option Image Removed');
export const modifierOptionKitchenNameChanged = catalogItemLibraryEventCreator('Modifier Option Kitchen Name Edited');
export const modifiersSearched = catalogItemLibraryEventCreator('Modifier Searched');
export const modifierSetApplyToItemsModalOpened = catalogItemLibraryEventCreator('Apply Modifier Set to Items Modal Opened');
export const modifierSetCharacterLimitErrorTriggered = catalogItemLibraryEventCreator('Modifier Character Limit Triggered');
export const modifierSetCreateBtnClicked = catalogItemLibraryEventCreator('New Modifier Set Creation Started');
export const modifierSetCreated = catalogItemLibraryEventCreator('Modifier Set Created');
export const modifierSetDeleted = catalogItemLibraryEventCreator('Modifier Set Deleted');
export const modifierSetDuplicated = catalogItemLibraryEventCreator('Modifier Set Duplicated');
export const modifierSetEdited = catalogItemLibraryEventCreator('Modifier Set Edited');
export const modifierSubunitsChanged = catalogItemLibraryEventCreator('Modifier Set Subunits Changed');
export const modifierUnappliedToItem = catalogItemLibraryEventCreator('Modifier Option Unapplied To Item');
export const modifierSetEditStarted = catalogItemLibraryEventCreator('Modifier Set Edit Started');
export const modifierChannelEnablementEdited = catalogItemLibraryEventCreator('Modifier Channel Enablement Edited');
export const modifierChannelAssignmentOpened = catalogItemLibraryEventCreator('Modifier Channel Assignment Opened');
export const modifierChannelLocationOverrideOpened = catalogItemLibraryEventCreator('Modifier Channel Location Override Opened');
export const modifierChannelLocationOverrideUpdated = catalogItemLibraryEventCreator('Modifier Channel Location Override Updated');

// Modifiers
export const modifierLibFilteredByType = catalogItemLibraryEventCreator('Modifier Type Filtered');
export const modifierLibPageLoadSuccess = catalogItemLibraryEventCreator('Modifier Page Load: Success');
export const modifierLibPageLoadError = catalogItemLibraryEventCreator('Modifier Page Load: Error');

// Item Modifiers
export const itemModifiersEdited = catalogItemLibraryEventCreator('Item Modifiers Edited');
export const itemAddModifiersModalOpened = catalogItemLibraryEventCreator('Add Modifiers Modal Opened');
export const itemResetModifiersOrderClicked = catalogItemLibraryEventCreator('Item Modifier Order Reset');

// Import
export const itemsImportSuccess = catalogItemLibraryEventCreator('Items Inventory Import: Success');
export const itemsImportError = catalogItemLibraryEventCreator('Items Inventory Import: Error');
export const itemsImportPartialSuccess = catalogItemLibraryEventCreator('Items Inventory Import: Partial Success');
export const itemsImportAutoResolveErrors = catalogItemLibraryEventCreator('Items Inventory Import: Auto-resolve error');
export const combinedItemsUnitCostImportSuccess = catalogItemLibraryEventCreator('Combined Items Unit Cost Import: Success');
export const combinedItemsUnitCostImportError = catalogItemLibraryEventCreator('Combined Items Unit Cost Import: Error');

// Export
export const itemsExport = catalogItemLibraryEventCreator('Items Inventory Export');
export const itemsExportError = catalogItemLibraryEventCreator('Items Inventory Export: Error');

// Download item library import template
export const itemLibraryImportTemplateDownloaded = catalogItemLibraryEventCreator('Item Library Import Template Downloaded');

// Items Library Paging
export const itemsLibraryPageLoaded = catalogItemLibraryEventCreator('Items Library Page Loaded');

// Services Library Paging
export const servicesLibraryPageLoaded = catalogItemLibraryEventCreator('Services Library Page Loaded');

// Item Library Filtering
export let FilteringSource = /*#__PURE__*/function (FilteringSource) {
  FilteringSource["Apply"] = "Apply";
  FilteringSource["Search"] = "Search";
  FilteringSource["Checkbox"] = "Checkbox";
  return FilteringSource;
}({});
export const itemsLibraryFiltered = catalogItemLibraryEventCreator('Items Library Filtered');
export const advancedFilteringBladeClosed = catalogItemLibraryEventCreator('Advanced Filters: Filter Blade Closed');
export const advancedFilteringBladeOpened = catalogItemLibraryEventCreator('Advanced Filters: Filter Blade Opened');
export const advancedFilteringBladeViewed = catalogItemLibraryEventCreator('Advanced Filters: Filter Blade Viewed');
export const advancedFilteringBladeReset = catalogItemLibraryEventCreator('Advanced Filters: Filters Reset');
export const advancedFilteringBladeResetApplied = catalogItemLibraryEventCreator('Advanced Filters: Filters Reset Applied');

// Item Library Load
export const itemsLibraryLoaded = catalogItemLibraryEventCreator('Items Library Loaded');

// Item Edit Sheet Opened
export const itemEditSheetOpened = catalogItemLibraryEventCreator('Item Edit Sheet Opened');

// Items Library Columns
export const itemsLibraryColumnEnabled = catalogItemLibraryEventCreator('Items Library Column Enabled');
export const itemsLibraryColumnDisabled = catalogItemLibraryEventCreator('Items Library Column Disabled');

// Item Edit Upon Opening "add Variation"
export const addVariationModalOpened = catalogItemLibraryEventCreator('Item Edit: Add Variation Modal Opened');

// Services Library Filtering
export const servicesLibraryFiltered = catalogItemLibraryEventCreator('Services Library Filtered');

// Edit Inventory at Location Modal
export const editInventoryAtLocationModalOpened = catalogItemLibraryEventCreator('Edit Inventory at Location Modal Openend');
export const editInventoryAtLocationModalReasonChanged = catalogItemLibraryEventCreator('Edit Inventory at Location Modal Reason Changed');

// Item Edit
export function toggleSkipsModifierScreen() {
  return inputEvent('Item Library: Edit: Skips modifier screen toggled');
}
export const itemEditTaxes = catalogItemLibraryEventCreator('Item Library: Tax Selector Modal Opened');

// Item category suggestion source
export const itemCategorySuggestionSource = {
  DEEP_CATALOG: 'Deep Catalog',
  UNIVERSAL_ITEM_SEARCH: 'Universal Item Search'
};

// Deep Catalog
export const categorySuggestionShown = catalogItemLibraryEventCreator('Suggestion: Category Suggestion Shown');
export const categorySuggestionAccepted = catalogItemLibraryEventCreator('Suggestion: Category Suggestion Accepted');
export const categorySuggestionSaved = catalogItemLibraryEventCreator('Suggestion: Category Suggestion Saved');

// Services
export const serviceCreated = catalogItemLibraryEventCreator('Service Created');
export const serviceDeleted = catalogItemLibraryEventCreator('Service Deleted');
export const serviceEdited = catalogItemLibraryEventCreator('Service Edited');
export const serviceGapTimeToggled = inputEvent('Gap Time Toggle Service');
export const serviceGapTimeModifyDuration = inputEvent('Modify Gap Time Duration');
export const serviceGapTimeInfoIconViewed = linkClickEvent('Gap Time Info Icon Viewed');
export const serviceGapTimeModalView = linkClickEvent('Gap Time Tip Modal: View');

// Resources
export const resourceCreated = catalogItemLibraryEventCreator('Resource Created');
export const resourceDeleted = catalogItemLibraryEventCreator('Resource Deleted');
export const resourceEdited = catalogItemLibraryEventCreator('Resource Edited');

// Fractional Quantities
// "id" of the event indicates the digits of precision of the measurement unit.
// "details" can be either "Standard" or "Custom".
export const variationCreatedWithUnit = catalogItemLibraryEventCreator('FQT: Variation Created with Unit');
export const variationAddedUnit = catalogItemLibraryEventCreator('FQT: Variation Added Unit');
export const variationRemovedUnit = catalogItemLibraryEventCreator('FQT: Variation Removed Unit');
export const variationChangedUnit = catalogItemLibraryEventCreator('FQT: Variation Changed Unit');

// Checkout Links
export function checkoutLinkCopied(linkId) {
  const metadata = {
    page_click_detail: `ITEM: ${linkId}`
  };
  return buttonClickEvent('Checkout Link: Link Copied', metadata);
}

// Item Options
export const optionSetCreated = catalogItemLibraryEventCreator('Item Options: Option Set Created');
export const optionSetEdited = catalogItemLibraryEventCreator('Item Options: Option Set Edited');
export const optionSetDeleted = catalogItemLibraryEventCreator('Item Options: Option Set Deleted');
export const optionAddedToOptionSet = catalogItemLibraryEventCreator('Item Options: Option Added to Option Set');
export const optionDeletedFromOptionSet = catalogItemLibraryEventCreator('Item Options: Option Deleted from Option Set');
export const optionOrderChangedInOptionSet = catalogItemLibraryEventCreator('Item Options: Option Order Changed in Option Set');
export const variationCreatedWithOptions = catalogItemLibraryEventCreator('Item Options: Variation Created with Options');
export const variationDeletedWithOptions = catalogItemLibraryEventCreator('Item Options: Variation Deleted with Options');
export const flatListVariationsConvertedToOptions = catalogItemLibraryEventCreator('Item Options: Flat List Variations Converted to Options');
export const optionSetOrderChangedOnItem = catalogItemLibraryEventCreator('Item Options: Option Set Order Changed on Item');
export const optionLearnMoreLinkClicked = catalogItemLibraryEventCreator('Item Options: Learn More Link was Clicked');

// Label printing
export const labelCreationSource = {
  ITEM_EDIT: 'Item Edit',
  PURCHASE_ORDER: 'Purchase Order',
  STOCK_OVERVIEW: 'Stock Overview'
};
export const labelCreated = catalogItemLibraryEventCreator('Label Printing: Label Created');

// Vendor management
export const vendorCodeAndUnitCostSetSource = {
  PURCHASE_ORDER: 'PO',
  ITEM_EDIT: 'Item Edit',
  VENDOR_LIBRARY: 'Vendor Library'
};
export const vendorCodeSet = catalogItemLibraryEventCreator('Vendor Code Set');
export const vendorUnitCostSet = catalogItemLibraryEventCreator('Vendor Unit Cost Set');
export const poLineItemNoteAdded = catalogItemLibraryEventCreator('PO Line Item Note Added');

// Custom Attributes
export const customAttributeValueAssigned = catalogItemLibraryEventCreator('Custom Attributes: Value Assigned');
export const customAttributeValueEdited = catalogItemLibraryEventCreator('Custom Attributes: Value Edited');
export const customAttributeValueDeleted = catalogItemLibraryEventCreator('Custom Attributes: Value Deleted');
export const customAttributeDefinitionCreated = catalogItemLibraryEventCreator('Custom Attributes: Definition Created');
export const customAttributeDefinitionEdited = catalogItemLibraryEventCreator('Custom Attributes: Definition Edited');
export const customAttributeDefinitionDeleted = catalogItemLibraryEventCreator('Custom Attributes: Definition Deleted');

// Sold Out
export const soldOutToggledOn = catalogItemLibraryEventCreator('Sold Out: Edit Variation Modal Row Toggled Sold Out On');
export const soldOutToggledOff = catalogItemLibraryEventCreator('Sold Out: Edit Variation Modal Row Toggled Sold Out Off');
export const soldOutSavedOn = catalogItemLibraryEventCreator('Sold Out: Edit Variation Modal Saved Sold Out On');
export const soldOutSavedOff = catalogItemLibraryEventCreator('Sold Out: Edit Variation Modal Saved Sold Out Off');
export const soldOutValidUntilBusinessHoursMissing = catalogItemLibraryEventCreator('Sold Out: Valid Until Business Hours Missing');

// Component Inventory
export const sellByCreateSource = {
  ITEM_EDIT_SHEET: 'Item Edit Sheet',
  ADD_VARIATION_MODAL: 'Add Variation Modal',
  EDIT_VARIATION_MODAL: 'Edit Variation Modal'
};
export const sellByCreateStarted = catalogItemLibraryEventCreator('Component Inventory: Sell-by Create Started');
export const sellByCreateCompleted = catalogItemLibraryEventCreator('Component Inventory: Sell-by Create Completed');
export const sellBySaved = catalogItemLibraryEventCreator('Component Inventory: Sell-by Saved');
export const sellByDefaultEdited = catalogItemLibraryEventCreator('Component Inventory: Sell-by Default Edited');
export const sellByConversionEdited = catalogItemLibraryEventCreator('Component Inventory: Sell-by Conversion Edited');
export const sellByDeleted = catalogItemLibraryEventCreator('Component Inventory: Sell-by Deleted');
export const stockableUnitChangedDone = catalogItemLibraryEventCreator('Component Inventory: Stockable Unit Updated');
export const stockableUnitChangedSave = catalogItemLibraryEventCreator('Component Inventory: Stockable Unit Saved');
export const sellableToggleSellableDone = catalogItemLibraryEventCreator('Component Inventory: Mark as Sellable (Done)');
export const sellableToggleNonsellableDone = catalogItemLibraryEventCreator('Component Inventory: Mark as Non-sellable (Done)');
export const sellableToggleSellableSaved = catalogItemLibraryEventCreator('Component Inventory: Mark as Sellable (Save)');
export const sellableToggleNonsellableSaved = catalogItemLibraryEventCreator('Component Inventory: Mark as Non-sellable (Save)');
export const advancedFilteringBladeForSale = catalogItemLibraryEventCreator('Items Library Filtered: For sale');

// Note that the following events are related to a feature fka "Easy Create", now referred to as "Auto Create" in product.
// Event names will remain the same for consistent reporting purposes.
// Easy Create Item
export const easyCreateStartedSource = {
  CREATE_ITEM: 'Create Item',
  EDIT_ITEM: 'Edit Item'
};

// Easy Create Related Variations Step Entrypoint
export const easyCreateRelatedVarEntrySource = {
  SEE_MORE: 'See more button',
  FIND_RELATED_VARIATIONS: 'Find related variations button'
};

// Easy Create Entry Source
export const easyCreateEntrySource = {
  NEW_ITEM: 'New Item',
  EXISTING_ITEM: 'Existing Item'
};
export const easyCreateSearchSource = {
  AUTO_CREATE_MODAL: 'Auto Create modal',
  EDIT_VARIATION_MODAL: 'Edit variation modal',
  SEARCH_CARD: 'Auto Create search card'
};

// Upon pageview of Easy-Create Item
export const itemCreationPageView = catalogItemLibraryEventCreator('Item Creation Pageview');

// Upon Click of "Auto Create" to open easy create modal
export const easyCreateClick = catalogItemLibraryEventCreator('Easy Create: Click');

// Upon seller starting to type / whenever suggestions lookup happens
export const easyCreateItemLookup = catalogItemLibraryEventCreator('Easy Create: Item Lookup');

// Upon Seller selecting an item
export const easyCreateItemSelection = catalogItemLibraryEventCreator('Easy Create: Item Selection');

// Upon selecting a suggested related variation
export const easyCreateVariationSelection = catalogItemLibraryEventCreator('Easy Create: Variation Selection/Add');

// Upon searching for related variations
export const easyCreateVariationLookup = catalogItemLibraryEventCreator('Easy Create: Variation Lookup');

// Upon Categories Loading/Upon Interaction with Categories
export const easyCreateCategoryHintsResults = catalogItemLibraryEventCreator('Easy Create: Category Hints Results');
export const easyCreateCategoryHintSelection = catalogItemLibraryEventCreator('Easy Create: Category Hint Selection');
export const easyCreateValuesPopulatedOnSave = catalogItemLibraryEventCreator('Easy Create: Values populated On Save');

// When a seller deletes an item that was added by Easy Create (aka Auto Create)
export const easyCreateImageRemoved = catalogItemLibraryEventCreator('Easy Create: Image Removed');

// Fired after fetching a fully generated description as part of the Auto Create flow
export const easyCreateGeneratedDescriptionResult = catalogItemLibraryEventCreator('Easy Create: Fully Generated Description Result');

// Fired when the user clicks on the "Remove" button for a fully generated description
export const easyCreateRemoveGeneratedDescription = catalogItemLibraryEventCreator('Easy Create: Remove Generated Description');

// Common items
export const commonImageSuggestionShown = catalogItemLibraryEventCreator('Common Items: Image Suggestion Shown');
export const commonImageSuggestionClicked = catalogItemLibraryEventCreator('Common Items: Image Suggestion Clicked');
export const commonImageSuggestionOverwritten = catalogItemLibraryEventCreator('Common Items: Image Suggestion Overwritten');

// Multiple Images
export const IMAGE_LIBRARY_ID = 'image library';
export const ITEM_QUICK_CREATE_TOKEN = 'item quick add';
export const ITEM_VARIATION_BULK_ADD_ID = 'bulk item variation';
export const imageLibraryLoaded = catalogItemLibraryEventCreator('Image Library: Loaded');
export const imageLibraryImagesUploaded = catalogItemLibraryEventCreator('Image Library: Images Uploaded');
export const imageLibraryImagesSelected = catalogItemLibraryEventCreator('Image Library: Images Selected');
export const imageLibraryImagesRemoved = catalogItemLibraryEventCreator('Image Library: Images Removed');
export const imageLibraryImagesSearched = catalogItemLibraryEventCreator('Image Library: Images Searched');
export const imageLibraryImagesSorted = catalogItemLibraryEventCreator('Image Library: Images Sorted');
export const imageLibraryImagesFiltered = catalogItemLibraryEventCreator('Image Library: Images Filtered');
export const imageLibraryImagesEdited = catalogItemLibraryEventCreator('Image Library: Image Edited');
export const imageLibraryImagesDeleted = catalogItemLibraryEventCreator('Image Library: Images Deleted');
export const imageLibrarySuggestedImageSelected = catalogItemLibraryEventCreator('Image Library: Suggested Image Selected');
export const imageLibrarySuggestedImagesUploaded = catalogItemLibraryEventCreator('Image Library: Suggested Images Uploaded');
export const imageLibrarySuggestedImagesShown = catalogItemLibraryEventCreator('Image Library : Suggested Images Shown');

// Item Library Quick Create
export const quickCreateActivated = catalogItemLibraryEventCreator('Quick Create: Activated');
export const quickCreateItemNameEntered = catalogItemLibraryEventCreator('Quick Create: Item Name Entered');
export const quickCreateItemPriceEntered = catalogItemLibraryEventCreator('Quick Create: Item Price Entered');

// Undo Catalog
export const undoCatalogItemImportUndoView = catalogItemLibraryEventCreator('Items Import Undo: View');
export const undoCatalogItemImportUndoSuccess = catalogItemLibraryEventCreator('Items Import Undo: Success');
export const undoCatalogItemImportUndoCancelled = catalogItemLibraryEventCreator('Items Import Undo: Cancelled');
export const undoCatalogItemImportUndoFailed = catalogItemLibraryEventCreator('Items Import Undo: Failed');

// Square Online Settings
export const editInSquareOnlineClicked = catalogItemLibraryEventCreator('Square Online: Edit in Square Online Link Clicked');

// Square Online Settings - Item Visibility
export const itemVisibilitySelected = catalogItemLibraryEventCreator('Item Visibility: Visibility Selected');
export const itemVisibilityHiddenLearnMoreClicked = catalogItemLibraryEventCreator('Item Visibility: Hidden Visibility Learn More Link Clicked');
export const itemVisibilitySyncSettingsBannerDismissed = catalogItemLibraryEventCreator('Item Visibility: Item Sync Settings Banner Dismissed');
export const itemVisibilityGoToSyncSettingsClicked = catalogItemLibraryEventCreator('Item Visibility: Item Sync Settings Banner Go To Link Clicked');
export const itemVisibilityGoToPreferenceSettingsClicked = catalogItemLibraryEventCreator('Item Visibility: Item Out of Stock Banner Go To Link Clicked');
export const itemVisibilityNoPriceAddPriceClicked = catalogItemLibraryEventCreator('Item Visibility: Add Price Dialog Add Price Button Clicked');
export const itemVisibilityNoPriceProceedClicked = catalogItemLibraryEventCreator('Item Visibility: Add Price Dialog Save and Close Button Clicked');
export const itemVisibilityNoPriceWarningShown = catalogItemLibraryEventCreator('Item Visibility: Missing Price Warning Shown');
export const itemVisibilitySomeOutOfStockBannerShown = catalogItemLibraryEventCreator('Item Visibility: Some Variations Out of Stock Banner Shown');
export const itemVisibilityOutOfStockWarningShown = catalogItemLibraryEventCreator('Item Visibility: Out of Stock Warning Shown');
export const itemVisibilityNoWarningsShown = catalogItemLibraryEventCreator('Item Visibility: No Warnings Shown');
export const itemVisibilityLocationSiteVisBannerShown = catalogItemLibraryEventCreator('Item Visibility: Location Site Visibility Warning Banner Shown');
export const itemVisibilityLocationSiteVisBannerLinkClicked = catalogItemLibraryEventCreator('Item Visibility: Location Site Visibility Banner Configure Locations Clicked');
export const itemVisibilityLocationFulfillmentEnablementBannerShown = catalogItemLibraryEventCreator('Item Visibility: Location Fulfillment Enablement Warning Banner Shown');
export const itemVisibilityLocationFulfillmentEnablementBannerLinkClicked = catalogItemLibraryEventCreator('Item Visibility: Location Fulfillment Enablement Banner Configure Locations Clicked');
export const itemVisibilityFulfillmentComboBannerShown = catalogItemLibraryEventCreator('Item Visibility: Fulfillment Combo Warning Banner Shown');
export const itemVisibilityFulfillmentComboBannerLinkClicked = catalogItemLibraryEventCreator('Item Visibility: Fulfillment Combo Warning Banner Configure Locations Clicked');
export const itemVisibilityBannerLearnMoreClicked = catalogItemLibraryEventCreator('Item Visibility: Banner Learn More Link Clicked');

// Square Online Settings - Channel Assignment
export const channelAssignmentToggleOn = catalogItemLibraryEventCreator('Channel Assignment: Toggle Channel On');
export const channelAssignmentToggleOff = catalogItemLibraryEventCreator('Channel Assignment: Toggle Channel Off');
export const channelAssignmentAddToAllChannelsClicked = catalogItemLibraryEventCreator('Channel Assignment: Add to all Button Clicked');
export const channelAssignmentRemoveFromAllChannelsClicked = catalogItemLibraryEventCreator('Channel Assignment: Remove from all Button Clicked');
export const channelAssignmentAddToChannelsClicked = catalogItemLibraryEventCreator('Channel Assignment: Add to Channels Button Clicked');
export const channelAssignmentManageChannelsClicked = catalogItemLibraryEventCreator('Channel Assignment: Manage Channels Button Clicked');
export const channelAssignmentCloseModalClicked = catalogItemLibraryEventCreator('Channel Assignment: Modal Closed');
export const channelAssignmentSaveModalClicked = catalogItemLibraryEventCreator('Channel Assignment: Modal Saved');
export const channelAssignmentSelectAllOnModalClicked = catalogItemLibraryEventCreator('Channel Assignment: Modal Select All');
export const channelAssignmentRemoveAllOnModalClicked = catalogItemLibraryEventCreator('Channel Assignment: Modal Remove All');
export const channelAssignmentSelectChannel = catalogItemLibraryEventCreator('Channel Assignment: Modal Select Channel');
export const channelAssignmentDeselectChannel = catalogItemLibraryEventCreator('Channel Assignment: Modal Deselect Channel');
export const channelAssignmentVisibilityConfirmationModalOpened = catalogItemLibraryEventCreator('Channel Assignment: Visibility Confirmation Modal Open');
export const channelAssignmentVisibilityConfirmationModalConfirmClicked = catalogItemLibraryEventCreator('Channel Assignment: Visibility Confirmation Modal Confirm Clicked');
export const channelAssignmentVisibilityConfirmationModalCancelClicked = catalogItemLibraryEventCreator('Channel Assignment: Visibility Confirmation Modal Cancel Clicked');
export const channelAssignmentAddOnlineChannelModalOpened = catalogItemLibraryEventCreator('Channel Assignment: Add Online Channel Modal Opened');
export const channelAssignmentAddOnlineChannelModalClosed = catalogItemLibraryEventCreator('Channel Assignment: Add Online Channel Modal Closed');
export const channelAssignmentMappingFailedSiteId = catalogItemLibraryEventCreator('Channel Assignment: Mapping Failed for Site ID');
export const channelAssignmentMappingFailedSiteDomain = catalogItemLibraryEventCreator('Channel Assignment: Mapping Failed for Site Domain');

// Square Online Settings - Fulfillment Methods
export const selectFulfillmentMethodsClicked = catalogItemLibraryEventCreator('Fulfillment Methods: Select Button Clicked');
export const editFulfillmentMethodsClicked = catalogItemLibraryEventCreator('Fulfillment Methods: Edit Button Clicked');
export const noFulfillmentMethodsSelectedBannerShown = catalogItemLibraryEventCreator('Fulfillment Methods: No Methods Warning Banner Shown');
export const fulfillmentMethodsCloseModalClicked = catalogItemLibraryEventCreator('Fulfillment Methods: Modal Closed');
export const fulfillmentMethodsSaveModalClicked = catalogItemLibraryEventCreator('Fulfillment Methods: Modal Saved');
export const fulfillmentMethodsSelectMethod = catalogItemLibraryEventCreator('Fulfillment Methods: Modal Select Method');
export const fulfillmentMethodsDeselectMethod = catalogItemLibraryEventCreator('Fulfillment Methods: Modal Deselect Method');
export const itemSavedAfterDeselectAllFulfillmentMethods = catalogItemLibraryEventCreator('Fulfillment Methods: Item Saved After De-selecting All Fulfillment Methods');

// Assign Shipping Box - The other events for this are triggered from the dashboard-fulfillment MFE
export const assignShippingBoxClicked = catalogItemLibraryEventCreator('Item Box Mapping: Click Open Assign Shipping Box');

// Committed Inventory
export const availableStockNumberClicked = catalogItemLibraryEventCreator('Committed Inventory: Available Stock number Clicked');
export const stockDetailsBladeViewed = catalogItemLibraryEventCreator('Committed Inventory: Stock details blade Viewed');
export const stockDetailsManageStockClicked = catalogItemLibraryEventCreator('Committed Inventory: Manage Stock button Clicked');
export const stockDetailsCommittedStockClicked = catalogItemLibraryEventCreator('Committed Inventory: Committed stock Clicked');
export const committedStockBladeViewed = catalogItemLibraryEventCreator('Committed Inventory: Committed stock details Viewed');
export const stockDetailsBladeLearnMoreClicked = catalogItemLibraryEventCreator('Committed Inventory: Learn more about committed stock Clicked');
export const stockDetailsBladeVariationsFiltered = catalogItemLibraryEventCreator('Committed Inventory: Variations Filtered');
export const stockDetailsBladeLocationsFiltered = catalogItemLibraryEventCreator('Committed Inventory: Locations Filtered');
export const COMMITTED_INVENTORY_SOURCES = {
  ITEM_LIBRARY: 'Item Library',
  STOCK_DETAILS_BLADE: 'Stock Details Blade',
  COMMITTED_STOCK_BLADE: 'Committed Stock Blade'
};
export const photoStudioBannerDismissed = catalogItemLibraryEventCreator('Photo Studio Banner: Dismissed');
export const photoStudioBannerShown = catalogItemLibraryEventCreator('Photo Studio Banner: Shown');
export const photoStudioBannerLearnMoreClicked = catalogItemLibraryEventCreator('Photo Studio Banner: Learn more link clicked');
export const photoStudioBannerAppStoreImageClicked = catalogItemLibraryEventCreator('Photo Studio Banner : App store image clicked');

// Bulk actions
export const bulkActionModalOpened = catalogItemLibraryEventCreator(BulkActionsEvents.MODAL_OPENED);
export const bulkActionModalDismissed = catalogItemLibraryEventCreator(BulkActionsEvents.MODAL_DISMISEED);
export const bulkActionInitiated = catalogItemLibraryEventCreator(BulkActionsEvents.MODAL_UPDATE_INITIATED);
export const bulkActionFailed = catalogItemLibraryEventCreator(BulkActionsEvents.ITEM_UPDATED_ERROR);
export const bulkActionSuccess = catalogItemLibraryEventCreator(BulkActionsEvents.ITEM_UPDATED_SUCCESS);

// Bulk item editing
export const bulkItemEditOpened = catalogItemLibraryEventCreator(BulkItemEditEvents.SHEET_OPENED);
export const bulkItemEditSuccess = catalogItemLibraryEventCreator(BulkItemEditEvents.SUCCESS);
export const bulkItemEditAborted = catalogItemLibraryEventCreator(BulkItemEditEvents.ABORTED);
export const bulkItemEditFailed = catalogItemLibraryEventCreator(BulkItemEditEvents.FAILED);
export const bulkItemEditFieldUpdate = catalogItemLibraryEventCreator(BulkItemEditEvents.EDITED_FIELD);
export const bulkItemEditRowAdded = catalogItemLibraryEventCreator(BulkItemEditEvents.ROW_ADDED);
export const bulkItemEditColumnAdded = catalogItemLibraryEventCreator(BulkItemEditEvents.COLUMN_ADDED);
export const bulkItemEditBulkImageModal = catalogItemLibraryEventCreator(BulkItemEditEvents.UPDLOAD_IMAGE_MODAL);
export const bulkItemEditBulkImageUpload = catalogItemLibraryEventCreator(BulkItemEditEvents.BULK_IMAGE_UPLOAD);

// Fixed Compositions
export const FIXED_COMPOSITION_SOURCES = {
  COMPONENT_SELECTION_MODAL: 'Component Selection Modal',
  ITEM_EDIT_SHEET: 'Item Edit Sheet',
  BUNDLE_CREATION: 'Bundle Creation',
  STOCK_BLADE: 'Component Stock Blade',
  ITEM_LIBRARY: 'Item Library',
  DUPLICATION: 'Bundle'
};
export const fixedCompositionToggled = catalogItemLibraryEventCreator('Bundling: Sell as a composition Clicked');
export const selectComponentsClicked = catalogItemLibraryEventCreator('Bundling: Select components Clicked');
export const fixedCompositionComponentsAdded = catalogItemLibraryEventCreator('Bundling: Components Added');
export const fixedCompositionComponentsSearched = catalogItemLibraryEventCreator('Bundling: Variations Searched');
export const fixedCompositionSaved = catalogItemLibraryEventCreator('Bundling: Bundle Created');
export const fixedCompositionSellByChanged = catalogItemLibraryEventCreator('Bundling: Component Unit Changed');
export const fixedCompositionStockBladeViewed = catalogItemLibraryEventCreator('Bundling: Component Stock Blade Viewed');
export const fixedCompositionStockBladeComponentClicked = catalogItemLibraryEventCreator('Bundling: Component Stock Clicked');
export const fixedCompositionStockBladeLocationsFiltered = catalogItemLibraryEventCreator('Bundling: Component Stock Blade Location Filtered');
export const fixedCompositionDuplicateStarted = catalogItemLibraryEventCreator('Bundling: Duplicate Bundle Started');

// Order Item Quantity Limits
export const orderItemQuantityLimitsUpgradeButtonClicked = catalogItemLibraryEventCreator('Order Item Quantity Limits: Upgrade button clicked');
export const orderItemQuantityLimitsToggledOff = catalogItemLibraryEventCreator('Order Item Quantity Limits: Toggled Off');
export const orderItemQuantityLimitsToggledOn = catalogItemLibraryEventCreator('Order Item Quantity Limits: Toggled On');

// Sold out modifiers
export const viewLocationAvailabilityModal = catalogItemLibraryEventCreator('Modifier Location Availability Modal Opened');
export const modifierMarkedSoldOut = catalogItemLibraryEventCreator('Modifier Marked as Sold Out');
export const modifierMarkedAvailable = catalogItemLibraryEventCreator('Modifier Marked as Available');

// Auto Write
export const seeAutoWriteCta = catalogItemLibraryEventCreator('See Auto Write CTA');
export const clickAutoWriteCta = catalogItemLibraryEventCreator('Click Auto Write CTA');
export const insertAutoWrittenDescription = catalogItemLibraryEventCreator('Insert Auto Written Description');
export const autoWriteValuesPopulatedOnSave = catalogItemLibraryEventCreator('Auto Write: Values populated on save');
export const autoWriteKeywordSuggestionResult = catalogItemLibraryEventCreator('Keyword Suggestion Result');
export const autoWriteKeywordSuggestionFailed = catalogItemLibraryEventCreator('Keyword Suggestion Failed');
export const autoWriteDescriptionResult = catalogItemLibraryEventCreator('Auto Write Description Result');
export const autoWriteDescriptionFailed = catalogItemLibraryEventCreator('Auto Write Description Failed');
export const removeAutoWrittenDescription = catalogItemLibraryEventCreator('Remove Auto Written Description');

// Ingredient Inventory
export const addIngredientsClicked = catalogItemLibraryEventCreator('Ingredient Inventory: Add Ingredients clicked');
export const addUnitClicked = catalogItemLibraryEventCreator('Ingredient Inventory: Add unit clicked');
export const ingredientsAdded = catalogItemLibraryEventCreator('Ingredient Inventory: Ingredients Added');
export const recipeSaved = catalogItemLibraryEventCreator('Ingredient Inventory: Recipe Saved');
export const unitAdded = catalogItemLibraryEventCreator('Ingredient Inventory: Unit Added');
export const unitChanged = catalogItemLibraryEventCreator('Ingredient Inventory: Unit Changed');

// Item Types
export const createItemTypeModalOpened = catalogItemLibraryEventCreator('Item Types: Create Item Type Modal Opened');
export const changeItemTypeModalOpened = catalogItemLibraryEventCreator('Item Types: Change Item Type Modal Opened');
export const itemTypeSelected = catalogItemLibraryEventCreator('Item Types: Item Type Selected');
export const itemTypeChangeCta = catalogItemLibraryEventCreator('Item Types: Item Type Changed');
export const itemTypeReferralLinkClicked = catalogItemLibraryEventCreator('Item Types: Referral Links Clicked');
export const defaultItemTypeUpdated = catalogItemLibraryEventCreator('Item Types: Default item type updated');
export const foodItemEdited = catalogItemLibraryEventCreator('Item Types: Food Edited');
export const donationEdited = catalogItemLibraryEventCreator('Item Types: Donation Edited');
export const invalidSuggestedDonationAmount = catalogItemLibraryEventCreator('Item Types: Invalid Suggested Donation Amount');
export const eventEdited = catalogItemLibraryEventCreator('Item Types: Edit event');
export const invalidEventLink = catalogItemLibraryEventCreator('Item Types: Invalid Event Link');

// Combos
export const comboItemTypeSelected = catalogItemLibraryEventCreator('Combos: Combo Creation Started');
export const comboChoiceModalOpened = catalogItemLibraryEventCreator('Combos: Combo Choice Modal Opened');
export const comboChoiceAdded = catalogItemLibraryEventCreator('Combos: Combo Choice Added');
export const comboChoiceModalObjectsFiltered = catalogItemLibraryEventCreator('Combos: Object Filtered');
export const comboChoiceDeleted = catalogItemLibraryEventCreator('Combos: Combo Choice Deleted');
export const comboSaved = catalogItemLibraryEventCreator('Combos: Combo Saved');
export const comboSlotObjectSearched = catalogItemLibraryEventCreator('Combos: Object Searched');
export const comboConfigureModalOpened = catalogItemLibraryEventCreator('Combos: Combo Configure Options Modal Opened');
export const comboMenuSaved = catalogItemLibraryEventCreator('Combos: Add to Menu');

// Is Alcohol
export const alcoholToggleOn = catalogItemLibraryEventCreator('Is Alcohol: Item Contains Alcohol Toggled On');
export const alcoholToggleOff = catalogItemLibraryEventCreator('Is Alcohol: Item Contains Alcohol Toggled Off');
export const alcoholEnablementEdited = catalogItemLibraryEventCreator('Is Alcohol: Item Contains Alcohol Enablement Edited');
export const alcoholLinkClicked = catalogItemLibraryEventCreator('Is Alcohol: Learn More Clicked');

// Manage Availability
export const availabilitySave = catalogItemLibraryEventCreator('Save Availability');